import { type User, UserType } from '@metadevprofile/shared';
import { adminRoutes } from '@/admin-user/constants/routes';
import { ROUTE_PREFIXES } from '@/common/constants/route-prefixes';
import { institutionRoutes } from '@/institution/constants/routes';
import { practitionerRoutes } from '@/practitioner/constants/routes';

export const getRouteByUserType = (user: User) => {
  if (user.type === UserType.INSTITUTION) {
    return ROUTE_PREFIXES.institution;
  }

  if (user.type === UserType.PRACTITIONER) {
    return ROUTE_PREFIXES.practitioner;
  }

  if (user.type === UserType.ADMIN) {
    return ROUTE_PREFIXES.admin;
  }

  throw new Error('Invalid user type');
};

export const getDashboardRoute = (user: User) => {
  if (user.type === UserType.INSTITUTION) return institutionRoutes.dashboard;
  if (user.type === UserType.PRACTITIONER) return practitionerRoutes.dashboard;
  if (user.type === UserType.ADMIN) return adminRoutes.dashboard;
  throw new Error('Invalid user type');
};

export const getProfileRoute = (user: User) => {
  if (user.type === UserType.INSTITUTION) return institutionRoutes.profile;
  if (user.type === UserType.PRACTITIONER) return practitionerRoutes.profile;
  throw new Error('Invalid user type');
};
